module.exports = __webpack_public_path__ + "static/sandy-0173175f73af09ea40309a49742f3862.jpg";